var a = document.querySelectorAll('.mega-menu');
  
console.log(a);
a.forEach(item => {
  const b = item.querySelector('.mega-menu__content')
  item.addEventListener('mouseover', () => {
    item.setAttribute('open','');
    console.log('open');
  });
  item.addEventListener('mouseleave', () => {
    item.removeAttribute('open');
  });

  b.addEventListener('mouseover', () => {
    item.setAttribute('open','');
    console.log('open');
  });
  b.addEventListener('mouseleave', () => {
    item.removeAttribute('open');
  });
  
})



/*document.addEventListener('DOMContentLoaded', function() {
    // Check if the current URL is a collection page and is not the 'newest' collection
    if (window.location.pathname.startsWith('/collections') && !window.location.pathname.endsWith('/new-arrivals-2024')) {
        // Check if the 'sort_by' parameter is not already set
     if (!window.location.search.includes('sort_by')) {
            // Append the 'sort_by' parameter with value 'created-descending'
          var newUrl = window.location.href + (window.location.search ? '&' : '?') + 'sort_by=created-descending';
            // Redirect to the updated URL
          window.location.replace(newUrl);
        }
   }
});*/



